import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

(pdfMake as any).vfs = pdfFonts;

export interface IDefinition {
  info?: any;
  pageSize?: any;
  pageOrientation?: any;
  content: any;
  styles?: any;
  pageMargins?: any;
  footer?: any;
}

export const exportToPDF = async (docDefinition: IDefinition): Promise<string> => {
  const pdfDocGenerator = pdfMake.createPdf(docDefinition);
  const data = await pdfDocGenerator.getBase64();
  return `data:application/pdf;base64,${data}`;
};